export const tvshows = [
  {
    id: "t1",
    type: "tv",
    title: "长安烟云",
    poster:
      "https://readdy.ai/api/search-image?query=An%20ancient%20Chinese%20city%20skyline%20with%20lanterns%20and%20pagodas%20at%20dusk%2C%20cinematic%20historical%20drama%20poster%20artwork%2C%20warm%20lantern%20lighting%2C%20rich%20crimson%20and%20gold%20color%20grading%2C%20minimalist%20centered%20composition%2C%20dark%20neutral%20gradient%20background%2C%20high%20detail%20premium%20series%20key%20art&width=400&height=600&seq=tv-poster-01&orientation=portrait",
    year: 2025,
    rating: 9.1,
    genres: ["古装", "悬疑"],
    region: "大陆",
    synopsis:
      "盛唐长安，一桩离奇的灯楼失火案牵出朝堂暗流。新任大理寺少卿与神秘画师联手查案，却发现真相远比想象中更为宏大。",
    director: "韩震",
    cast: ["萧景行", "苏合香", "裴无咎"],
    episodeCount: 36,
    updatedTo: "更新至第 28 集",
    views: 2456000,
    tags: ["古装", "悬疑", "权谋", "大陆"],
    featured: true,
    tagline: "一城烟云，半部盛唐",
    heroImage:
      "https://readdy.ai/api/search-image?query=Epic%20wide%20ancient%20Chinese%20city%20at%20dusk%20with%20lanterns%20pagodas%20and%20misty%20mountains%2C%20historical%20drama%20film%20still%2C%20warm%20crimson%20and%20gold%20color%20grading%2C%20atmospheric%2C%20wide%20cinematic%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=tv-hero-01&orientation=landscape",
  },
  {
    id: "t2",
    type: "tv",
    title: "律政先锋",
    poster:
      "https://readdy.ai/api/search-image?query=A%20confident%20lawyer%20standing%20in%20a%20modern%20glass%20courthouse%20hall%2C%20cinematic%20legal%20drama%20poster%20artwork%2C%20clean%20dramatic%20lighting%2C%20cool%20grey%20and%20amber%20color%20grading%2C%20minimalist%20centered%20composition%2C%20dark%20neutral%20gradient%20background%2C%20high%20detail%20premium%20series%20key%20art&width=400&height=600&seq=tv-poster-02&orientation=portrait",
    year: 2024,
    rating: 8.7,
    genres: ["都市", "职场"],
    region: "大陆",
    synopsis:
      "一群年轻律师在一家老牌律所中摸爬滚打，他们要为弱者发声，也要在职业理想与现实规则之间找到属于自己的答案。",
    director: "林之浩",
    cast: ["顾言", "唐若薇", "许南风"],
    episodeCount: 32,
    updatedTo: "全 32 集",
    views: 1876000,
    tags: ["都市", "职场", "律政", "大陆"],
  },
  {
    id: "t3",
    type: "tv",
    title: "青春纪事",
    poster:
      "https://readdy.ai/api/search-image?query=A%20group%20of%20students%20on%20a%20sunny%20campus%20lawn%20with%20books%2C%20cinematic%20youth%20drama%20poster%20artwork%2C%20bright%20natural%20lighting%2C%20fresh%20warm%20color%20grading%2C%20minimalist%20centered%20composition%2C%20clean%20neutral%20gradient%20background%2C%20high%20detail%20premium%20series%20key%20art&width=400&height=600&seq=tv-poster-03&orientation=portrait",
    year: 2024,
    rating: 8.3,
    genres: ["青春", "校园"],
    region: "大陆",
    synopsis:
      "高三的最后一年，六个性格迥异的少年在同一个班级里相遇，他们在试卷与梦想之间，写下了属于自己的青春纪事。",
    director: "苏晴",
    cast: ["陆知夏", "林一", "许安然"],
    episodeCount: 24,
    updatedTo: "全 24 集",
    views: 1423000,
    tags: ["青春", "校园", "成长", "大陆"],
  },
  {
    id: "t4",
    type: "tv",
    title: "迷雾档案",
    poster:
      "https://readdy.ai/api/search-image?query=A%20detective%20examining%20case%20files%20in%20a%20dim%20office%20with%20fog%20outside%2C%20cinematic%20mystery%20crime%20poster%20artwork%2C%20moody%20lighting%2C%20cold%20teal%20and%20amber%20color%20grading%2C%20minimalist%20centered%20composition%2C%20dark%20neutral%20gradient%20background%2C%20high%20detail%20premium%20series%20key%20art&width=400&height=600&seq=tv-poster-04&orientation=portrait",
    year: 2025,
    rating: 8.9,
    genres: ["悬疑", "犯罪"],
    region: "大陆",
    synopsis:
      "一份尘封二十年的旧档案重新被翻开，刑警队长发现每一桩新案都能在旧卷宗里找到影子，而真相，藏在迷雾最深处。",
    director: "高远",
    cast: ["秦峰", "苏黎", "赵岩"],
    episodeCount: 28,
    updatedTo: "更新至第 20 集",
    views: 1698000,
    tags: ["悬疑", "犯罪", "烧脑", "大陆"],
  },
  {
    id: "t5",
    type: "tv",
    title: "豪门风云",
    poster:
      "https://readdy.ai/api/search-image?query=A%20luxurious%20mansion%20with%20a%20family%20silhouette%20against%20large%20windows%2C%20cinematic%20family%20drama%20poster%20artwork%2C%20elegant%20dramatic%20lighting%2C%20warm%20gold%20color%20grading%2C%20minimalist%20centered%20composition%2C%20dark%20neutral%20gradient%20background%2C%20high%20detail%20premium%20series%20key%20art&width=400&height=600&seq=tv-poster-05&orientation=portrait",
    year: 2023,
    rating: 8.0,
    genres: ["剧情", "家族"],
    region: "大陆",
    synopsis:
      "一场突如其来的遗产争夺，让表面和睦的家族分崩离析。三个子女各怀秘密，而老爷子的真实遗嘱，藏在谁也没想到的地方。",
    director: "钱世昌",
    cast: ["袁正则", "白雅琴", "袁靖"],
    episodeCount: 40,
    updatedTo: "全 40 集",
    views: 1205000,
    tags: ["剧情", "家族", "商战", "大陆"],
  },
  {
    id: "t6",
    type: "tv",
    title: "星际拓荒者",
    poster:
      "https://readdy.ai/api/search-image?query=A%20space%20colony%20under%20a%20giant%20alien%20sky%20with%20ships%20taking%20off%2C%20cinematic%20science%20fiction%20series%20poster%20artwork%2C%20epic%20lighting%2C%20cool%20cyan%20and%20amber%20color%20grading%2C%20minimalist%20centered%20composition%2C%20dark%20neutral%20gradient%20background%2C%20high%20detail%20premium%20series%20key%20art&width=400&height=600&seq=tv-poster-06&orientation=portrait",
    year: 2025,
    rating: 8.8,
    genres: ["科幻", "冒险"],
    region: "欧美",
    synopsis:
      "人类第一支星际拓荒舰队抵达宜居行星，却在这片新土地上发现，拓荒从来不是征服，而是与未知共存的开始。",
    director: "丹尼尔·科尔",
    cast: ["伊森·瑞德", "纳塔莉·格林", "卢卡斯·金"],
    episodeCount: 16,
    updatedTo: "更新至第 12 集",
    views: 2103000,
    tags: ["科幻", "冒险", "太空", "欧美"],
    featured: true,
    tagline: "星辰之下，人类从不停止远征",
    heroImage:
      "https://readdy.ai/api/search-image?query=Epic%20wide%20futuristic%20space%20colony%20with%20departing%20ships%20under%20an%20alien%20sky%2C%20science%20fiction%20series%20still%2C%20cool%20cyan%20and%20amber%20color%20grading%2C%20atmospheric%2C%20wide%20cinematic%20composition%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=tv-hero-02&orientation=landscape",
  },
  {
    id: "t7",
    type: "tv",
    title: "医者仁心",
    poster:
      "https://readdy.ai/api/search-image?query=A%20surgeon%20in%20scrubs%20standing%20in%20a%20bright%20hospital%20corridor%2C%20cinematic%20medical%20drama%20poster%20artwork%2C%20clean%20clinical%20lighting%2C%20soft%20teal%20and%20white%20color%20grading%2C%20minimalist%20centered%20composition%2C%20clean%20neutral%20gradient%20background%2C%20high%20detail%20premium%20series%20key%20art&width=400&height=600&seq=tv-poster-07&orientation=portrait",
    year: 2024,
    rating: 8.4,
    genres: ["职场", "剧情"],
    region: "大陆",
    synopsis:
      "急诊科里每天都上演着生离死别，一群医务工作者在高压与抉择中坚守岗位，也在彼此身上找回了最初的热忱。",
    director: "董南",
    cast: ["沈知行", "方怡", "高铭"],
    episodeCount: 30,
    updatedTo: "全 30 集",
    views: 1338000,
    tags: ["职场", "剧情", "医疗", "大陆"],
  },
  {
    id: "t8",
    type: "tv",
    title: "江湖夜雨",
    poster:
      "https://readdy.ai/api/search-image?query=A%20swordsman%20standing%20in%20the%20rain%20on%20an%20old%20town%20street%2C%20cinematic%20wuxia%20martial%20arts%20poster%20artwork%2C%20dramatic%20backlighting%2C%20ink%20blue%20and%20amber%20color%20grading%2C%20minimalist%20centered%20composition%2C%20dark%20neutral%20gradient%20background%2C%20high%20detail%20premium%20series%20key%20art&width=400&height=600&seq=tv-poster-08&orientation=portrait",
    year: 2023,
    rating: 8.6,
    genres: ["武侠", "古装"],
    region: "大陆",
    synopsis:
      "退隐多年的剑客因一封故人之约重入江湖，却发现当年的恩怨早已被新一代的野心改写。十步杀一人，只为守一句承诺。",
    director: "楚山",
    cast: ["萧无极", "雨未歇", "沈孤鸿"],
    episodeCount: 38,
    updatedTo: "全 38 集",
    views: 1512000,
    tags: ["武侠", "古装", "国风", "大陆"],
  },
  {
    id: "t9",
    type: "tv",
    title: "欢乐邻居",
    poster:
      "https://readdy.ai/api/search-image?query=A%20cheerful%20apartment%20building%20courtyard%20with%20neighbors%20chatting%2C%20cinematic%20comedy%20series%20poster%20artwork%2C%20bright%20warm%20lighting%2C%20vivid%20colorful%20grading%2C%20minimalist%20centered%20composition%2C%20clean%20neutral%20gradient%20background%2C%20high%20detail%20premium%20series%20key%20art&width=400&height=600&seq=tv-poster-09&orientation=portrait",
    year: 2024,
    rating: 7.9,
    genres: ["喜剧", "都市"],
    region: "大陆",
    synopsis:
      "一栋老小区里住着一群鸡毛蒜皮的邻居，每天上演着啼笑皆非的小故事，吵吵闹闹之间，却成了彼此最温暖的依靠。",
    director: "贺聪",
    cast: ["贾乐", "马小玲", "何大明"],
    episodeCount: 20,
    updatedTo: "全 20 集",
    views: 976000,
    tags: ["喜剧", "都市", "下饭", "大陆"],
  },
  {
    id: "t10",
    type: "tv",
    title: "帝国黄昏",
    poster:
      "https://readdy.ai/api/search-image?query=An%20ancient%20emperor%20throne%20hall%20with%20dramatic%20columns%20and%20banners%2C%20cinematic%20historical%20epic%20poster%20artwork%2C%20low%20key%20golden%20lighting%2C%20deep%20crimson%20and%20gold%20color%20grading%2C%20minimalist%20centered%20composition%2C%20dark%20neutral%20gradient%20background%2C%20high%20detail%20premium%20series%20key%20art&width=400&height=600&seq=tv-poster-10&orientation=portrait",
    year: 2022,
    rating: 9.0,
    genres: ["历史", "古装"],
    region: "大陆",
    synopsis:
      "一个庞大帝国走到命运的转折点，年轻的帝王、忠诚的老臣与野心勃勃的藩镇，共同谱写了一曲荡气回肠的黄昏挽歌。",
    director: "崔明道",
    cast: ["李承乾", "魏之涣", "独孤信"],
    episodeCount: 48,
    updatedTo: "全 48 集",
    views: 1988000,
    tags: ["历史", "古装", "权谋", "大陆"],
  },
  {
    id: "t11",
    type: "tv",
    title: "心跳信号",
    poster:
      "https://readdy.ai/api/search-image?query=A%20couple%20standing%20close%20on%20a%20rooftop%20under%20city%20lights%2C%20cinematic%20romance%20series%20poster%20artwork%2C%20soft%20bokeh%20lighting%2C%20warm%20rose%20and%20amber%20color%20grading%2C%20minimalist%20centered%20composition%2C%20dark%20neutral%20gradient%20background%2C%20high%20detail%20premium%20series%20key%20art&width=400&height=600&seq=tv-poster-11&orientation=portrait",
    year: 2025,
    rating: 8.1,
    genres: ["爱情", "都市"],
    region: "日韩",
    synopsis:
      "一位情感电台主播和一位冷静的数据分析师意外成为合租室友，一个用声音治愈别人，一个却从不相信心动，直到信号终于对上频率。",
    director: "金睿恩",
    cast: ["韩世妍", "车佑镇", "朴敏浩"],
    episodeCount: 16,
    updatedTo: "更新至第 10 集",
    views: 1376000,
    tags: ["爱情", "都市", "甜宠", "日韩"],
  },
  {
    id: "t12",
    type: "tv",
    title: "追光者",
    poster:
      "https://readdy.ai/api/search-image?query=A%20young%20athlete%20sprinting%20on%20a%20track%20at%20sunrise%2C%20cinematic%20inspirational%20sports%20poster%20artwork%2C%20dramatic%20sunrise%20lighting%2C%20warm%20amber%20color%20grading%2C%20minimalist%20centered%20composition%2C%20dark%20neutral%20gradient%20background%2C%20high%20detail%20premium%20series%20key%20art&width=400&height=600&seq=tv-poster-12&orientation=portrait",
    year: 2024,
    rating: 8.2,
    genres: ["励志", "运动"],
    region: "大陆",
    synopsis:
      "一个被判定再也无法站上赛道的短跑少年，在退役教练的帮助下重新出发，用每一次冲刺追赶那道属于自己的光。",
    director: "冯竞",
    cast: ["徐飞扬", "林希", "韩教练"],
    episodeCount: 26,
    updatedTo: "全 26 集",
    views: 1149000,
    tags: ["励志", "运动", "热血", "大陆"],
  },
];